export default function createGeoLink(lat: string | number, long: string | number) {
    return `https://maps.google.com/?q=${lat},${long}`
}